import { Box, Button, Grid, Typography } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import { digitsFaToEn } from 'persian-tools2';
import { useEffect, useState } from 'react';
import moment from 'jalali-moment';
import { ReportCustomDatePicker } from './date-picker';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  p: '24px 20px 24px',
  width: '90%',
  height: 'auto',
  fontFamily: 'dana-bold',
  background: '#F5F5F5',
  border: '1px solid #FFFFFF',
  boxShadow: ' 8px 8px 20px rgba(172, 172, 172, 0.5), -8px -8px 20px #FFFFFF',
  borderRadius: '16px',
  textAlign: 'center',
  color: '#707070'
};

const btnStyle = (isActive) => ({
  fontSize: { md: '24px' },
  width: { xs: '126px', md: '223px' },
  height: { xs: '30px', md: '64px' },
  border: '1px solid #FFFFFF',
  color: isActive ? '#753CBE' : '#ACACAC',
  borderRadius: '16px',
  pt: '9px',
  textTransform: 'capitalize',
  fontFamily: 'dana-bold',
  boxShadow: '4px 4px 15px 0px #00000014, -2px -2px 4px 0px #FFFFFF'
});

export function DatePickerModal({
  getData,
  isOpen,
  closeHandler,
  date,
  setDate
}) {
  const [hideModal, setHideModal] = useState(false);

  const fromDate = moment(date.from, 'jYYYY-jMM-jDD');
  const toDate = moment(date.to, 'jYYYY-jMM-jDD');
  const toDateisAfterOrSame =
    toDate.isAfter(fromDate) || toDate.isSame(fromDate);

  const startDateHandler = (value) =>
    setDate((prev) => ({ ...prev, from: digitsFaToEn(value) }));

  const endtDateHandler = (value) =>
    setDate((prev) => ({ ...prev, to: digitsFaToEn(value) }));

  useEffect(() => {
    if (date.to && toDate.isBefore(fromDate)) {
      endtDateHandler(null);
    }
  }, [date]);

  return (
    <div style={{ width: '100%' }}>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={isOpen}
        onClose={closeHandler}
        closeAfterTransition
        BackdropComponent={Backdrop}
        hideBackdrop
      >
        <>
          <Backdrop
            onClick={closeHandler}
            sx={{
              background: 'rgba(216, 216, 216, 0.3)',
              backdropFilter: 'blur(6.7957px)',
              transition: 'ease-in-out 0.2s !important'
            }}
            open={isOpen}
          />
          <Fade in={isOpen}>
            <Grid
              container
              sx={[
                style,
                {
                  width: { md: '604px' },
                  padding: {
                    md: '48px 64px 64px'
                  }
                }
              ]}
              style={{ visibility: hideModal && 'hidden' }}
            >
              <Typography
                sx={{
                  fontSize: { xs: '16px', md: '24px' },
                  fontFamily: 'dana-bold',
                  lineHeight: '25px',
                  textAlign: 'center',
                  color: '#6F4D9F',
                  width: '100%',
                  marginBottom: { xs: '24px', md: '48px' }
                }}
              >
                Date Selection
              </Typography>
              <Typography
                sx={{
                  fontSize: { xs: '14px', md: '24px' },
                  textAlign: 'center',
                  width: '100%',
                  lineHeight: { xs: '30px', md: '40px' },
                  marginBottom: { xs: '24px', md: '64px' }
                }}
              >
                To view the report in your desired period, please select the
                Start and End dates below
              </Typography>

              <Grid item xs={12}>
                <ReportCustomDatePicker
                  label="start"
                  value={date.from}
                  onChange={startDateHandler}
                  date={date}
                  setHideModal={setHideModal}
                  minDate="1400/01/01"
                  maxDate={moment().locale('fa').format('YYYY/MM/DD')}
                />
                <ReportCustomDatePicker
                  setHideModal={setHideModal}
                  value={date.to}
                  onChange={endtDateHandler}
                  date={date}
                  minDate={date.from ? digitsFaToEn(date.from) : '1400/01/01'}
                  maxDate={moment().locale('fa').format('YYYY/MM/DD')}
                />
              </Grid>
              <Box
                sx={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'space-between',
                  mt: { xs: '43px', md: '64px' }
                }}
              >
                <Button
                  disabled={!date.from || !date.to || !toDateisAfterOrSame}
                  sx={btnStyle(date.from && date.to)}
                  onClick={getData}
                >
                  View Report
                </Button>
                <Button
                  sx={{
                    fontSize: { md: '24px' },
                    color: '#979797',
                    textTransform: 'capitalize',
                    fontFamily: 'dana-bold'
                  }}
                  onClick={closeHandler}
                >
                  Cancel
                </Button>
              </Box>
            </Grid>
          </Fade>
        </>
      </Modal>
    </div>
  );
}
